import { render, staticRenderFns } from "./DoubleSystemMemoView.vue?vue&type=template&id=e6aa567c&scoped=true&"
import script from "./DoubleSystemMemoView.vue?vue&type=script&lang=js&"
export * from "./DoubleSystemMemoView.vue?vue&type=script&lang=js&"
import style0 from "./DoubleSystemMemoView.vue?vue&type=style&index=0&id=e6aa567c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6aa567c",
  null
  
)

export default component.exports